export const REQUEST_A_SIGNUP_LINK = 'signup/requestASignupLink';
export const REQUEST_A_SIGNUP_LINK_START = 'signup/requestASignupLinkStart';
export const REQUEST_A_SIGNUP_LINK_COMPLETE = 'signup/requestASignupLinkCompleted';
export const REQUEST_A_SIGNUP_LINK_ERROR = 'signup/requestASignupLinkError';

export const VERIFY_EMAIL = 'signup/verifyEmail';
export const VERIFY_EMAIL_START = 'signup/verifyEmailStart';
export const VERIFY_EMAIL_COMPLETE = 'signup/verifyEmailCompleted';
export const VERIFY_EMAIL_ERROR = 'signup/verifyEmailError';

export const VERIFY_PHONE_NUMBER = 'signup/verifyPhoneNumber';
export const VERIFY_PHONE_NUMBER_START = 'signup/verifyPhoneNumberStart';
export const VERIFY_PHONE_NUMBER_COMPLETE = 'signup/verifyPhoneNumberCompleted';
export const VERIFY_PHONE_NUMBER_ERROR = 'signup/verifyPhoneNumberError';

export const VERIFY_PHONE_NUMBER_OTP = 'signup/verifyPhoneNumberOtp';
export const VERIFY_PHONE_NUMBER_OTP_START = 'signup/verifyPhoneNumberOtpStart';
export const VERIFY_PHONE_NUMBER_OTP_COMPLETE = 'signup/verifyPhoneNumberOtpCompleted';
export const VERIFY_PHONE_NUMBER_OTP_ERROR = 'signup/verifyPhoneNumberOtpError';

export const CREATE_PASSWORD = 'signup/createPassword';
export const CREATE_PASSWORD_START = 'signup/createPasswordStart';
export const CREATE_PASSWORD_COMPLETE = 'signup/createPasswordCompleted';
export const CREATE_PASSWORD_ERROR = 'signup/createPasswordError';

export const CLEAR_SIGNUP_ERROR = 'signup/clearSignUpErrors';

export const clearSignUpErrors = (payload = {}) => ({
  type: CLEAR_SIGNUP_ERROR,
  payload,
});

export const verifyEmail = (payload = {}) => ({
  type: VERIFY_EMAIL,
  payload,
});

export const requestASignupLink = (payload = {}) => ({
  type: REQUEST_A_SIGNUP_LINK,
  payload,
});

export const verifyPhoneNumber = (payload = {}) => ({
  type: VERIFY_PHONE_NUMBER,
  payload,
});

export const verifyPhoneNumberOtp = (payload = {}) => ({
  type: VERIFY_PHONE_NUMBER_OTP,
  payload,
});

export const createPassword = (payload = {}) => ({
  type: CREATE_PASSWORD,
  payload,
});
